import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
// import ReactDOMServer from 'react-dom/server';
// import Html from 'react-pdf-html';

// Define styles for your document
const styles = StyleSheet.create({
  page: {
    padding: 30,
    backgroundColor: "#f8f9fa",
  },
  title: {
    fontSize: 18,
    textAlign: "center",
    marginBottom: 20,
    fontWeight: "bold",
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    // width: "150px",
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#e0e0e0",
    padding: 6,
  },
  tableCol: {
    // width: "150px",
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 6,
  },
  tableCellHeader: {
    fontSize: 12,
    fontWeight: "bold",
  },
  tableCell: {
    fontSize: 10,
    wrap: true, // IMPORTANT: allows long text to wrap
  },
});

const HistoryPDF = ({ data }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>

          <Text style={styles.title}>History Report</Text>

          {/* header row */}
          <View style={styles.table}>
            {/* Table Header */}
            {/* <View style={[styles.tableRow, styles.tableHeader]}>
              <Text style={styles.tableCol}>Address</Text>
              <Text style={styles.tableCol}>Name</Text>
              <Text style={styles.tableCol}>Date</Text>
            </View> */}
            <View style={styles.tableRow}>
            <View wrap={true} style={styles.tableColHeader}>
              <Text  style={styles.tableCellHeader}>Address</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Name</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Date</Text>
            </View>
          </View>


            {/* Table Body */}
            {/* {data.map((item, index) => (
              <View style={styles.tableRow} key={index}>
                <Text style={styles.tableCol}>{item.walletAddress}</Text>
                <Text style={styles.tableCol}>{item.name}</Text>
                <Text style={styles.tableCol}>{item.date}</Text>
              </View>
            ))} */}

            {/* body row */}
            {data.map((item, index) => (
          <View style={styles.tableRow} key={index}>
            <View wrap style={styles.tableCol}>
              <Text wrap style={styles.tableCell}>
                { item.walletAddress.length <= 32 ? 
                item.walletAddress :
                item.walletAddress.slice(0, -14) + " " + item.walletAddress.slice(-14)
                }
              </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>
                {item.name.length <= 25 ?
                  item.name :
                  item.name.slice(0, -14) + " " + item.name.slice(-14)
                }
                {/* {item.name} */}
                </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>
              {item.date}
              </Text>
            </View>
          </View>
             ))}
          </View>
      </Page>
    </Document>
  )
};

export default HistoryPDF;